import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/context";
import { Reveal } from "@/components/Reveal";

export default function International() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["6%", "-6%"]);

  return (
    <section
      ref={ref}
      data-testid="international-section"
      className="relative bg-dark text-ivory py-32 sm:py-44 overflow-hidden"
    >
      <motion.div style={{ y }} className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 relative">
        <Reveal className="flex items-center gap-4 mb-10">
          <span className="gold-rule w-14" aria-hidden="true" />
          <span className="text-[11px] sm:text-xs uppercase tracking-[0.34em] text-gold">
            {t.international.eyebrow}
          </span>
        </Reveal>

        <Reveal delay={0.1}>
          <h2
            data-testid="international-title"
            className="font-serif text-4xl sm:text-6xl lg:text-7xl font-medium leading-[1.06] max-w-4xl"
          >
            {t.international.title}
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <p
            data-testid="international-copy"
            className="mt-8 max-w-xl text-base sm:text-lg text-taupe leading-relaxed font-light"
          >
            {t.international.copy}
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div data-testid="international-regions" className="mt-16 flex flex-wrap items-baseline gap-x-8 gap-y-4">
            {t.international.regions.map((r, i) => (
              <span key={r} className="flex items-baseline gap-8">
                {i > 0 && <span className="w-1.5 h-1.5 bg-gold rotate-45 self-center" aria-hidden="true" />}
                <span className="font-serif text-3xl sm:text-5xl text-outline-taupe uppercase tracking-wide">
                  {r}
                </span>
              </span>
            ))}
          </div>
        </Reveal>
      </motion.div>
    </section>
  );
}
